module.exports = __webpack_public_path__ + "static/img/beta_bg_11.0b1f3a63.svg";